import { useState } from "react";
import { client } from '../apiClient';
import { listBreeds } from '../graphql/queries';
import { Typeahead, withAsync } from 'react-bootstrap-typeahead';

import {
    View,
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
const AsyncTypeahead = withAsync(Typeahead);


export default function BreedSearch({ onChange, defaultInputValue, disabled, ariaLabel }) {

    const [items, setItems] = useState([]);
    const [lastquery, setLastQuery] = useState('');
    const [isSearching, setIsSearching] = useState(false);



    async function searchBreeds(query) {
        // Require a minimum query length so we never fire the unbounded list fetch.
        if (!query || query.trim().length < 3) {
            setItems([]);
            return [];
        }
        let breeds = [];
        setIsSearching(true);
        try {
            let filter = { lc_label: { contains: query?.toLowerCase() } }
            let response = await client.graphql({ query: listBreeds, variables: { filter: filter, limit: 1000 } });
            breeds = response?.data?.listBreeds?.items || [];
            setLastQuery(query);
            setItems(breeds);
        } catch (error) {
            console.error('BreedSearch failed:', JSON.stringify(error));
            // Surface an empty state rather than crashing on an unhandled rejection.
            setItems([]);
        } finally {
            setIsSearching(false);
        }
        return breeds;
    }


    return (
        <View>
            <AsyncTypeahead
                id="get-quote-typeahead"
                inputProps={{ id: 'pet-breed-input', 'aria-label': ariaLabel || 'Pet breed' }}
                onChange={onChange}
                isLoading={isSearching}
                minLength={3}
                onSearch={(query) => searchBreeds(query)}
                options={items}
                useCache={true}
                promptText={'Type in 3 characters of breed'}
                emptyLabel={'No matching breed'}
                defaultInputValue={defaultInputValue ? defaultInputValue: lastquery}
                disabled={disabled}
                ignoreDiacritics={true}
                flip={true}
                //autoFocus={true}
            />
        </View>
    );

}

